<template>
  <div id="app">    
      <router-view></router-view>
    </div>
</template>

<script src="assets/js/flutterwave.js"></script>
<script src="assets/js/vendor/jquery-1.12.0.min.js"></script>
<script src="assets/js/popper.js"></script>
<script src="assets/js/bootstrap.min.js"></script>
<script src="assets/js/imagesloaded.pkgd.min.js"></script>
<script src="assets/js/isotope.pkgd.min.js"></script>
<script src="assets/js/ajax-mail.js"></script>
<script src="assets/js/owl.carousel.min.js"></script>
<script src="assets/js/plugins.js"></script>
<script src="assets/js/main.js"></script>

<script>
  export default {
    name: 'App',
  }
</script>

<style>
  @import './assets/css/bootstrap.min.css';
  @import './assets/css/font-awesome.min.css';
  @import './assets/css/bootstrap.min.css';
  @import './assets/css/animate.css';
  @import './assets/css/owl.carousel.min.css';
  @import './assets/css/slick.css';
  @import './assets/css/chosen.min.css';
  @import './assets/css/font-awesome.min.css';
  @import './assets/css/simple-line-icons.css';
  @import './assets/css/ionicons.min.css';
  @import './assets/css/meanmenu.min.css';
  @import './assets/css/style.css';
  @import './assets/css/responsive.css';
  @import './assets/css/style2.css';
  @import './assets/css/everything_homecare.css';
</style>


